import ComplicationSelector from '@ls/grouping-complication-selector';
import React, {useCallback} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {setDefinition} from 'state/traceAnalytics/actions';
import TraceAnalyticDefinition from 'state/traceAnalytics/TraceAnalyticDefinition';
import {selectDefinitions} from 'state/traceAnalytics/selectors';
import SelectionState from 'state/selections/SelectionState';
import ComplicationComponent from './TraceAnalyticsSelectorComplication';

const TraceAnalyticsSelector = (props) => {
  const dispatch = useDispatch();
  const definitions = useSelector(selectDefinitions(SelectionState.UNCOMMITTED));
  const setDefinitionCallback = useCallback(
    (idx, definition) => dispatch(setDefinition(idx, definition)),
        [dispatch]
  );
  return (
    <ComplicationSelector
      selectedDefinitions={definitions}
      setDefinition={setDefinitionCallback}
      getDefaultDefinition={TraceAnalyticDefinition.getDefault}
      ComplicationComponent={ComplicationComponent}
      btnTitle="Trace Analytics"
      addMoreText="Trace Analytic Column"
    />
  );
};

export default TraceAnalyticsSelector;
